export interface TaxValidation {
  numIdentification: string;
  noCuit: boolean;
  IIBBCondition: string;
  IIBBNumber: string;
  IIBBJurisdiction?: string;
  municipalContribution?: boolean | null;
  REBA?: boolean;
  infoREBA?: RebaDto;
  infoAfip?: InfoAfip;
  infoCuil?: InfoCuil;
  aliCuota: number[];
  name: string;
  lastName: string;
  nameComplete: string;
  directionSame?: boolean;
  attachIIBBDocument?: IIBBDocumentCategory;
  numMunicipalContribution?: string;
  arbaPadron?: boolean;
  cbaPadron?: boolean;
  erPadron?: boolean;
  sfPadron?: boolean;
  categorizedAfip?: boolean;
}

export interface IIBBDocumentCategory {
  upload: boolean;
  required: boolean;
}

export interface RebaDto {
  expiredDate: Date;
  code: string;
}

export interface DataAfipDto {
  condicionIVA?: string;
  datosGenerales: DatosGenerales;
  condicionIIBB?: number;
  RSCiudadCoroba: boolean;
  name: string |undefined;
  lastName: string | undefined;
  isCuil: boolean;
}

export interface FiscalData {
  codPostal: string;
  descripcionProvincia: string;
  direccion: string;
  idProvincia: number;
  tipoDomicilio: string;
  localidad: string;
}

export interface DatosGenerales {
  domicilioFiscal: FiscalData;
  razonSocial: string;
  tipoPersona: string;
  nombre: string;
  apellido: string;
  tipoClave:string;
}

export interface InfoAfip {
  bussinesName: string;
  taxResidence: string;
  typePerson: string;
  ivaCondition: string;
  SH: boolean;
  convenioMultilateral: boolean;
  simplifiedMonotributo: boolean;
  municipalContribution: string;
  categorizedAfip?: boolean;
}

export interface InfoCuil {
  name: string;
  lastName: string;
  bussinesName: string;
  typePerson: string;
}

export interface GeoapifyResult {
  query: string;
  latitud: string;
  logintud: string;
}

export enum Padrones {
  Cordoba = 1,
  BuenosAires = 2,
  EntreRios = 3,
  SantaFe = 4,
}

export class TypePerson {
  public static readonly JURIDICA = 'J';
  public static readonly FISICA = 'F';
}

export class Constants {
  public static readonly REBA: string = 'REBA';
  public static readonly CONTRIBUTION_MUNICIPAL: string = 'CONTRIBUCION_MUNICIPAL';
  public static readonly CONDICION_IIBB: string = 'CONDICION_IIBB';
}

export const StateName = {
  Cordoba: 'córdoba',
  BuenosAires: 'buenos aires',
  EntreRios: 'entre ríos',
  SantaFe: 'santa fe',
}
